import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { PropTypes } from 'prop-types'
import { withStyles, Checkbox, Grid, Button, FormControlLabel } from '@material-ui/core'
import * as actions from '../actions'
import carretDown from '../images/svg/carret-down.svg'
import carretUp from '../images/svg/carret-up.svg'
import check from '../images/svg/tick.svg'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router'
import queryString from 'query-string'
import PriceRangeSlider from './PriceRangeSlider'
import Area from './AreaRangeSlider'
import { amtFmt } from '../utils'

const TABLET_BREAKPOINT = process.env.REACT_APP_TABLET_BREAKPOINT

const styles = theme => ({
  root: {
    color: '#9e9e9e',
    display: 'block',
    marginRight: '15px',
    '&$checked': {
      color: '#00bcb5',
    },
  },
  checked: {},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  filterH2: {
    fontSize: '27px',
    fontWeight: '500',
    color: '#333645',
    margin: '0 0 24px',
  },
  filterH4: {
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '0.89',
    letterSpacing: '1.3px',
    color: '#333645',
    margin: '0 0 20px',
    textAlign: 'left',
  },
  filterChecklabel: {
    width: '100%',
    marginLeft: '0',
    marginTop: '10px',
    marginBottom: '10px',
    alignItems: 'flex-start',
    '& span': {
      '&:first-child': {
        width: '20px',
        height: '20px',
        margin: '-1px 0 0',
        display: 'block',
        padding: '0px',
        marginRight: '10px',
        '& svg': {
          width: '20px',
          height: '20px',
        },
      },
      '&:last-child': {
        fontSize: '15px',
        marginLeft: '0',
        paddingLeft: '0',
        lineHeight: '17px',
      },
    },
  },
  formControl: {
    '& selectEmpty': {
      '&:hover': {
        '&:before': {
          border: '0px',
        },
      },
    },
  },
  '& selectEmpty': {
    '& > div': {
      '& > div': {
        color: '#a9aeba',
        fontSize: '15px',
        display: 'flex',
        padding: '0',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50px',
      },
    },
  },
  nmbrOfBeds: {
    display: 'flex',
    justifyContent: 'space-between',
    '& span': {
      width: '48px',
      height: '48px',
      borderRadius: '4px',
      border: 'solid 1px #00bcb5',
      fontSize: '16px',
      lineHeight: '2',
      color: '#333645',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    '& selectedSpan': {
      backgroundColor: '#00bcb5',
      color: '#ffffff',
    },
  },
  bgGreen: {
    backgroundColor: '#00bcb5',
    color: '#ffffff !important',
  },
  applyFilterBtn: {
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '1.13',
    color: 'rgba(255, 255, 255, 0.8)',
    width: '100%',
    height: '52px',
    borderRadius: '4px',
    backgroundColor: '#00bcb5',
    '&:hover': {
      backgroundColor: '#00bcb5',
      color: '#ffffff',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '80px',
    },
  },
  filterContent: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  // css below for new filter
  filterWrapper: {
    position: 'fixed',
    zIndex: '11',
    top: '64px',
    left: '0',
    right: '0',
    width: '100%',
    textAlign: 'center',
    height: '64px',
    backgroundColor: 'rgb(233, 244, 243)',
    margin: '0',
    padding: '10px 6px',
    [theme.breakpoints.down('960')]: {
      top: '48px',
    },
    [theme.breakpoints.down('480')]: {
      height: 'auto',
    },
  },
  selectRoot: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
    [theme.breakpoints.down('480')]: {
      flexWrap: 'wrap',
    },
  },
  customNativeSelect: {
    '& > div': {
      backgroundColor: '#ffffff',
      height: '44px',
      margin: '0 6px',
      border: 'solid 2px rgba(182, 182, 182, 0.25)',
      borderRadius: '2px',
      '& select': {
        padding: '11px',
        fontSize: '15px',
        lineHeight: '1.33',
        color: '#404552',
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  customSelect: {
    '& > div': {
      backgroundColor: '#ffffff',
      height: '44px',
      maxWidth: '145px',
      margin: '0 6px',
      border: 'solid 2px rgba(182, 182, 182, 0.25)',
      borderRadius: '2px',
      '& > div': {
        padding: '11px',
        fontSize: '15px',
        lineHeight: '1.33',
        color: '#404552',
        textAlign: 'left',
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  viewMapbtn: {
    height: '44px',
    minWidth: '145px',
    margin: '0 6px',
    border: 'solid 1px rgba(182, 182, 182, 0.25)',
    borderRadius: '2px',
    backgroundColor: '#ffffff',
    display: 'none',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
    [theme.breakpoints.down('768')]: {
      display: 'inline-block',
    },
    [theme.breakpoints.down('480')]: {
      width: 'calc(100% / 2 - 12px)',
      minWidth: 'auto',
    },
    '& span': {
      fontSize: '14px',
      color: '#333645',
      lineHeight: '1.21',
      fontWeight: '100',
      textTransform: 'initial',
    },
  },
  viewFilterbtn: {
    height: '44px',
    minWidth: '145px',
    margin: '0 6px',
    border: 'solid 1px rgba(182, 182, 182, 0.25)',
    borderRadius: '2px',
    backgroundColor: '#ffffff',
    display: 'none',
    backgroundImage: `url(${carretDown})`,
    backgroundRepeat: 'no-repeat',
    appearance: 'none',
    backgroundPosition: 'center right',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
    '&.active': {
      border: 'solid 1px #37bab5',
      backgroundImage: `url(${carretUp})`,
    },
    [theme.breakpoints.down('768')]: {
      display: 'inline-block',
    },
    [theme.breakpoints.down('480')]: {
      width: 'calc(100% / 2 - 12px)',
      minWidth: 'auto',
    },
    '& span': {
      fontSize: '14px',
      color: '#333645',
      lineHeight: '1.21',
      fontWeight: '100',
      textTransform: 'initial',
    },
  },
  moreFilterbtn: {
    height: '44px',
    width: 'calc(100% / 7)',
    margin: '0 6px',
    border: 'solid 1px rgba(182, 182, 182, 0.25)',
    borderRadius: '2px',
    backgroundColor: '#ffffff',
    display: 'none',
    backgroundImage: `url(${carretDown})`,
    backgroundRepeat: 'no-repeat',
    appearance: 'none',
    backgroundPosition: 'center right',
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
    '&.active': {
      border: 'solid 1px #37bab5',
      backgroundImage: `url(${carretUp})`,
    },
    [theme.breakpoints.down('1024')]: {
      width: 'calc(100% / 5)',
      display: 'flex',
    },
    [theme.breakpoints.down('768')]: {
      display: 'none',
    },
    '& span': {
      fontSize: '14px',
      color: '#333645',
      lineHeight: '1.21',
      fontWeight: '100',
      textTransform: 'initial',
    },
  },
  customSelectWrapper: {
    display: 'flex',
    width: 'calc(100% / 7)',
    [theme.breakpoints.down('1024')]: {
      width: 'calc(100% / 5)',
    },
  },
  proTypeSelectWrapper: {
    display: 'flex',
    [theme.breakpoints.down('768')]: {
      display: 'none',
    },
  },
  priRangeWrapper: {
    display: 'flex',
    [theme.breakpoints.down('768')]: {
      display: 'none',
    },
  },
  bedSelectWrapper: {
    display: 'flex',
    [theme.breakpoints.down('768')]: {
      display: 'none',
    },
  },
  bathSelectWrapper: {
    display: 'flex',
    [theme.breakpoints.down('1024')]: {
      display: 'none',
    },
  },
  areaRangeWrapper: {
    display: 'flex',
    [theme.breakpoints.down('1024')]: {
      display: 'none',
    },
  },
  homeTypeSelectWrapper: {
    display: 'flex',
    [theme.breakpoints.down('1024')]: {
      display: 'none',
    },
  },
  sortBySelectWrapper: {
    display: 'flex',
    [theme.breakpoints.down('1024')]: {
      order: '5',
    },
    [theme.breakpoints.down('768')]: {
      order: '5',
      minWidth: '145px',
      width: 'auto',
    },
    [theme.breakpoints.down('480')]: {
      order: '3',
      width: '100%',
      margin: '10px 0 0',
    },
  },
  commonSelect: {
    height: '44px',
    width: 'calc(100% - 12px)',
    margin: '0 6px',
    border: 'solid 1px rgba(182, 182, 182, 0.25)',
    flexGrow: 1,
    borderRadius: '2px',
    backgroundColor: '#ffffff',
    fontSize: '15px',
    color: '#404552',
    padding: '11px 12px',
    textAlign: 'left',
    backgroundImage: `url(${carretDown})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center right',
    cursor: 'pointer',
    appearance: 'none',
    '& span': {
      maxWidth: '90%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
      textTransform: 'capitalize',
    },
    '&.active': {
      border: 'solid 1px #37bab5',
      backgroundImage: `url(${carretUp})`,
    },
  },
  mobileFilters: {
    position: 'fixed',
    zIndex: '101',
    top: '112px',
    left: '0',
    backgroundColor: '#ffffff',
    padding: '20px 0',
    maxHeight: 'calc(100vh - (64px + 48px))',
    overflow: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    [theme.breakpoints.up('768')]: {
      display: 'none !important',
    },
    '& marginBottom22': {
      marginBottom: '22px',
    },
    '& marginBottom38': {
      marginBottom: '38px',
    },
    '& marginBottom44': {
      marginBottom: '44px',
    },
    '& marginBottom47': {
      marginBottom: '47px',
    },
    '& > div': {
      width: '290px',
    },
    '& div': {
      margin: '0 auto 30px',
    },
  },
  tabFilters: {
    position: 'fixed',
    zIndex: '101',
    top: '112px',
    right: '0',
    left: 'auto',
    backgroundColor: '#ffffff',
    padding: '20px',
    width: '338px',
    minHeight: 'calc(100vh - (64px + 64px))',
    height: '100vh',
    overflow: 'auto',
    '& div': {
      margin: '0 auto 30px',
    },
    [theme.breakpoints.down('768')]: {
      display: 'none !important',
    },
    [theme.breakpoints.up('768')]: {
      display: 'flex',
    },
    [theme.breakpoints.up('960')]: {
      top: '128px',
    },
    [theme.breakpoints.up('1024')]: {
      display: 'none !important',
    },
  },
  commonFilterCss: {
    position: 'fixed',
    zIndex: '101',
    top: '119px !important',
    right: 'auto',
    left: 'auto',
    backgroundColor: '#ffffff',
    width: '258px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.09)',
    border: 'solid 1px #ececec',
    padding: '0',
    marginLeft: '-7px',
    [theme.breakpoints.down('640')]: {
      display: 'none',
    },
    [theme.breakpoints.down('960')]: {
      top: '103px !important',
    },
    [theme.breakpoints.up('768')]: {
      display: 'flex',
    },
    [theme.breakpoints.up('960')]: {
      top: '128px',
    },
    [theme.breakpoints.up('1024')]: {
      display: 'flex',
    },
  },
  sortBySelectList: {
    left: 'auto',
    right: '12px',
    padding: '8px 0',
    fontSize: '16px',
    lineHeight: '1',
    minWidth: '220px',
    maxHeight: '280px',
    color: '#333645',
    '& ul': {
      margin: '0',
      padding: '0',
      listStyle: 'none',
      cursor: 'pointer',
      '& li': {
        padding: '5px 30px',
        fontSize: '16px',
        lineHeight: '1.5',
        color: '#333645',
        position: 'relative',
        '&$checked': {
          '&:before': {
            content: `url(${check})`,
            position: 'absolute',
            left: '12px',
          },
        },
        '&:hover': {
          backgroundColor: '#e2f6f5',
        },
      },
    },
    [theme.breakpoints.down('768')]: {
      right: 'calc((100%/5) + 5px)',
    },
    [theme.breakpoints.down('480')]: {
      top: '158px !important',
      left: '19px',
      width: 'calc(100% - 24px)',
    },
  },
  filterListScroller: {
    maxHeight: '260px',
    overflow: 'auto',
    padding: '8px 15px',
    '-webkit-overflow-scrolling': 'touch',
    [theme.breakpoints.down(641)]: {
      maxHeight: '170px',
    },
  },
  propTypeFilter: {
    left: '20px',
    [theme.breakpoints.down('1024')]: {
      right: '146px',
    },
    [theme.breakpoints.down('768')]: {
      right: 'auto',
    },
  },
  priceRangeFilter: {
    left: 'calc(100%/7 + 17px)',
    right: 'auto',
    width: '300px',
    padding: '20px 20px 30px',
    [theme.breakpoints.down('1024')]: {
      left: 'calc(100%/5 + 13px)',
    },
  },
  bedFilter: {
    left: 'calc(((100%/7)*2) + 16px)',
    right: 'auto',
    width: '300px',
    padding: '20px 20px 20px',
    [theme.breakpoints.down('1024')]: {
      left: 'calc((100%/5)*2 + 10px)',
    },
  },
  bathFilter: {
    left: 'calc(((100%/7)*3) + 14px)',
    right: 'auto',
    width: '300px',
    padding: '20px 20px 20px',
  },
  areaRangeFilter: {
    left: 'calc(((100%/7)*4) + 12px)',
    right: 'auto',
    width: '300px',
    padding: '20px 20px 30px',
  },
  homeTypeFilter: {
    left: 'calc(((100%/7)*5) + 10px)',
  },
  filterMenu: {
    padding: '14px 20px',
    backgroundColor: '#ffffff !important',
    '& > span': {
      color: '#dddddd',
      width: '16px',
      '&.checked': {
        color: '#00bcb5',
      },
    },
    '& .filterItems': {
      '& span': {
        fontSize: '16px',
        color: '#333645',
      },
    },
  },
})

const TYPES = {
  PROPERTY: 'propertyTypes',
  HOME: 'homeTypes',
}

class Filters extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      [TYPES['PROPERTY']]: [],
      [TYPES['HOME']]: [],
      noOfBedRooms: 0,
      noOfBathRooms: 0,
      minPrice: '',
      maxPrice: '',
      minArea: '',
      maxArea: '',
      name: [],
      priceRange: [],
      areaRange: [],
      showFilterPanel: false,
      toggleFilterTabPanel: false,
      propertyTypeVisible: false,
      priceRangeVisible: false,
      bedSelectVisible: false,
      bathSelectVisible: false,
      homeTypeVisible: false,
      areaTypeVisible: false,
      sortByVisible: false,
      moreFilterVisible: false,
      bounds: {},
      width: window.innerWidth,
    }
  }

  sortBySelect = () => {
    if (!this.state.sortByVisible) {
      document.addEventListener('click', this.handleOutsideSortByClick, false)
      this.setState({
        propertyTypeVisible: false,
        priceRangeVisible: false,
        bedSelectVisible: false,
        homeTypeVisible: false,
        bathSelectVisible: false,
        areaTypeVisible: false,
        moreFilterVisible: false,
        toggleFilterTabPanel: false,
      })
    } else {
      document.removeEventListener('click', this.handleOutsideSortByClick, false)
    }
    this.setState(prevState => ({
      sortByVisible: !prevState.sortByVisible,
    }))
  }
  handleAreaTypeClick = () => {
    if (!this.state.areaTypeVisible) {
      document.addEventListener('click', this.handleOutsideAreaClick, false)
      this.setState({
        propertyTypeVisible: false,
        priceRangeVisible: false,
        bedSelectVisible: false,
        homeTypeVisible: false,
        bathSelectVisible: false,
        sortByVisible: false,
        moreFilterVisible: false,
      })
    } else {
      document.removeEventListener('click', this.handleOutsideAreaClick, false)
    }
    this.setState(prevState => ({
      areaTypeVisible: !prevState.areaTypeVisible,
    }))
  }
  handlePropertyTypeClick = () => {
    if (!this.state.propertyTypeVisible) {
      document.addEventListener('click', this.handleOutsidePropertyClick, false)
      this.setState({
        areaTypeVisible: false,
        priceRangeVisible: false,
        bedSelectVisible: false,
        homeTypeVisible: false,
        bathSelectVisible: false,
        toggleFilterTabPanel: false,
        sortByVisible: false,
        moreFilterVisible: false,
      })
    } else {
      document.removeEventListener('click', this.handleOutsidePropertyClick, false)
    }
    this.setState(prevState => ({
      propertyTypeVisible: !prevState.propertyTypeVisible,
    }))
  }
  handlePriceRangeClick = () => {
    if (!this.state.priceRangeVisible) {
      document.addEventListener('click', this.handleOutsidePriceRangeClick, false)
      this.setState({
        areaTypeVisible: false,
        propertyTypeVisible: false,
        bedSelectVisible: false,
        homeTypeVisible: false,
        bathSelectVisible: false,
        toggleFilterTabPanel: false,
        sortByVisible: false,
        moreFilterVisible: false,
      })
    } else {
      document.removeEventListener('click', this.handleOutsidePriceRangeClick, false)
    }
    this.setState(prevState => ({
      priceRangeVisible: !prevState.priceRangeVisible,
    }))
  }
  bedSelectClick = () => {
    if (!this.state.bedSelectVisible) {
      document.addEventListener('click', this.handleOutsidebedSelectClick, false)
      this.setState({
        areaTypeVisible: false,
        propertyTypeVisible: false,
        priceRangeVisible: false,
        homeTypeVisible: false,
        bathSelectVisible: false,
        toggleFilterTabPanel: false,
        sortByVisible: false,
        moreFilterVisible: false,
      })
    } else {
      document.removeEventListener('click', this.handleOutsidebedSelectClick, false)
    }
    this.setState(prevState => ({
      bedSelectVisible: !prevState.bedSelectVisible,
    }))
  }
  bathSelectClick = () => {
    if (!this.state.bathSelectVisible) {
      document.addEventListener('click', this.handleOutsidebathSelectClick, false)
      this.setState({
        areaTypeVisible: false,
        propertyTypeVisible: false,
        priceRangeVisible: false,
        homeTypeVisible: false,
        bedSelectVisible: false,
        sortByVisible: false,
        moreFilterVisible: false,
      })
    } else {
      document.removeEventListener('click', this.handleOutsidebathSelectClick, false)
    }
    this.setState(prevState => ({
      bathSelectVisible: !prevState.bathSelectVisible,
    }))
  }
  homeTypeClick = () => {
    if (!this.state.homeTypeVisible) {
      document.addEventListener('click', this.handleOutsidehomeTypeClick, false)
      this.setState({
        areaTypeVisible: false,
        propertyTypeVisible: false,
        priceRangeVisible: false,
        bedSelectVisible: false,
        bathSelectVisible: false,
        sortByVisible: false,
        moreFilterVisible: false,
      })
    } else {
      document.removeEventListener('click', this.handleOutsidehomeTypeClick, false)
    }
    this.setState(prevState => ({
      homeTypeVisible: !prevState.homeTypeVisible,
    }))
  }
  handleOutsideSortByClick = e => {
    if (e && ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      sortByVisible: false,
    })
  }
  handleOutsidebathSelectClick = e => {
    if (ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      bathSelectVisible: false,
    })
  }
  handleFilterOutsideTypeClick = e => {
    if (ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      toggleFilterTabPanel: false,
      showFilterPanel: false,
      moreFilterVisible: false,
    })
  }
  handleOutsideAreaClick = e => {
    if (ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      areaTypeVisible: false,
    })
  }
  handleOutsidePropertyClick = e => {
    if (ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      propertyTypeVisible: false,
    })
  }
  handleOutsidePriceRangeClick = e => {
    if (ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      priceRangeVisible: false,
    })
  }
  handleOutsidebedSelectClick = e => {
    if (ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      bedSelectVisible: false,
    })
  }
  handleOutsidehomeTypeClick = e => {
    if (ReactDOM.findDOMNode(this).contains(e.target)) {
      return
    }
    this.setState({
      homeTypeVisible: false,
    })
  }

  handleChange = event => {
    this.setState({ name: event.target.value })
  }
  handlePriceRange = event => {
    this.setState({ priceRange: event.target.value })
  }
  toggleFilterPanel = () => {
    this.setState({
      showFilterPanel: !this.state.showFilterPanel,
      sortByVisible: false,
    })
  }
  showMoreFilterPanel = () => {
    if (!this.state.showFilterPanel) {
      document.addEventListener('click', this.handleFilterOutsideTypeClick, false)
      this.setState({
        showFilterPanel: !this.state.showFilterPanel,
        toggleFilterTabPanel: !this.state.toggleFilterTabPanel,
        propertyTypeVisible: false,
        priceRangeVisible: false,
        bedSelectVisible: false,
        sortByVisible: false,
        moreFilterVisible: !this.state.moreFilterVisible,
      })
    } else {
      document.removeEventListener('click', this.handleFilterOutsideTypeClick, false)
    }
    this.setState(prevState => ({
      showFilterPanel: !prevState.showFilterPanel,
    }))
  }

  receivePriceRange = (minPrice, maxPrice) => {
    this.setState(
      {
        minPrice: minPrice,
        maxPrice: maxPrice,
      },
      () => {
        this.handleApplyFilterClick()
      }
    )
  }
  receiveAreaRange = (minArea, maxArea) => {
    this.setState(
      {
        minArea: minArea,
        maxArea: maxArea,
      },
      () => {
        this.handleApplyFilterClick()
      }
    )
  }
  componentDidMount() {
    const { actions } = this.props
    actions.fetchPropertyFilters()
    const queryStr = queryString.parse(this.props.location.search)
    this.setState(
      {
        [TYPES['PROPERTY']]: queryStr.propertyType ? queryStr.propertyType.split(',') : [],
        [TYPES['HOME']]: queryStr.homeType ? queryStr.homeType.split(',') : [],
        noOfBedRooms: queryStr.numberOfBedrooms ? Number(queryStr.numberOfBedrooms) : 0,
        noOfBathRooms: queryStr.numberOfBath ? Number(queryStr.numberOfBath) : 0,
        minPrice: queryStr.min ? Number(queryStr.min) : this.state.minPrice ? this.state.minPrice : 0,
        maxPrice: queryStr.max ? Number(queryStr.max) : this.state.maxPrice ? this.state.maxPrice : 0,
        minArea: queryStr.minArea ? Number(queryStr.minArea) : this.state.minArea ? this.state.minArea : 0,
        maxArea: queryStr.maxArea ? Number(queryStr.maxArea) : this.state.maxArea ? this.state.maxArea : 0,
      },
      () => {
        this.props.actions.updateFilters(this.state.bounds, this.getFilterObj(), this.state.width < TABLET_BREAKPOINT)
      }
    )
    this.props.actions.handleSorting(queryStr.sortBy, queryStr.order)
  }
  componentDidUpdate(prevProps) {
    if (prevProps.filterTypes !== this.props.filterTypes && this.state.minArea === 0) {
      this.setState({
        minArea: this.state.minArea === 0 ? this.props.filterTypes[1].value[0] : this.state.minArea,
        maxArea: this.state.maxArea === 0 ? this.props.filterTypes[1].value[1] : this.state.maxArea,
        minPrice: this.state.minPrice === 0 ? this.props.filterTypes[0].value[0] : this.state.minPrice,
        maxPrice: this.state.maxPrice === 0 ? this.props.filterTypes[0].value[1] : this.state.maxPrice,
      })
    }
    if (!this.props.viewPort.equals(prevProps.viewPort)) {
      const bounds = {
        ne: {
          lat: this.props.viewPort.getIn(['northeast', 'lat']),
          lng: this.props.viewPort.getIn(['northeast', 'lng']),
        },
        sw: {
          lat: this.props.viewPort.getIn(['southwest', 'lat']),
          lng: this.props.viewPort.getIn(['southwest', 'lng']),
        },
      }
      this.setState({ bounds: bounds })
    }
  }
  componentWillMount() {
    //close all the filter panel on device orientationchange change
    let self = this
    window.addEventListener('resize', this.handleResize)
    window.addEventListener(
      'orientationchange',
      function() {
        self.setState({
          showFilterPanel: false,
          toggleFilterTabPanel: false,
          propertyTypeVisible: false,
          priceRangeVisible: false,
          bedSelectVisible: false,
          bathSelectVisible: false,
          homeTypeVisible: false,
          areaTypeVisible: false,
          sortByVisible: false,
          moreFilterVisible: false,
        })
      },
      false
    )
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.handleOutsidehomeTypeClick, false)
    document.removeEventListener('click', this.handleOutsidebedSelectClick, false)
    document.removeEventListener('click', this.handleOutsidePriceRangeClick, false)
    document.removeEventListener('click', this.handleOutsidePropertyClick, false)
    document.removeEventListener('click', this.handleOutsideAreaClick, false)
    document.removeEventListener('click', this.handleOutsidebathSelectClick, false)
    document.removeEventListener('click', this.handleOutsideSortByClick, false)
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('click', this.handleFilterOutsideTypeClick, false)
    this.props.actions.handleSorting()
    this.props.actions.updateFilters(this.state.bounds, this.setDefaultFilterObj(), false)
  }

  handleResize = () => {
    this.setState({ width: window.innerWidth })
  }

  updateURLFromChangeEvt() {
    const {
      match: { params },
    } = this.props
    const { sortBy, sortOrder } = this.props.filters
    const query = queryString.parse(this.props.location.search)
    const searchString = `address=${query.address}&propertyType=${this.state[TYPES['PROPERTY']].join(',')}&homeType=${this.state[TYPES['HOME']].join(
      ','
    )}&numberOfBedrooms=${this.state.noOfBedRooms}&numberOfBath=${this.state.noOfBathRooms}&min=${this.state.minPrice}&max=${
      this.state.maxPrice
    }&sortBy=${sortBy}&order=${sortOrder}&minArea=${this.state.minArea}&maxArea=${this.state.maxArea}`
    this.props.history.push({
      pathname: params.propertyID ? `/properties/${params.propertyID}` : `/properties`,
      search: searchString,
    })
  }
  handleTypesChange(evt, name) {
    let typesArr = this.state[name]
    let typeVal = evt.target.value
    if (evt.target.checked) {
      typesArr.push(typeVal)
    } else {
      typesArr.splice(typesArr.indexOf(typeVal), 1)
    }
    this.setState(
      {
        [name]: typesArr,
      },
      () => {
        this.handleApplyFilterClick()
      }
    )
  }

  handleBedRoomsClick(number) {
    if (this.state.noOfBedRooms !== number) {
      this.setState(
        {
          noOfBedRooms: number,
        },
        () => {
          this.handleApplyFilterClick()
        }
      )
    }
  }
  handleBathRoomsClick(number) {
    if (this.state.noOfBathRooms !== number) {
      this.setState(
        {
          noOfBathRooms: number,
        },
        () => {
          this.handleApplyFilterClick()
        }
      )
    }
  }

  handleApplyFilterClick() {
    this.props.actions.updateFilters(this.props.boundsFromMap, this.getFilterObj())
    this.updateURLFromChangeEvt()
  }
  applySelectedFilters() {
    this.setState({
      toggleFilterTabPanel: false,
      showFilterPanel: false,
      moreFilterVisible: false,
    })
  }
  getFilterObj() {
    return {
      propertyTypesSelected: this.state[TYPES['PROPERTY']],
      priceMinimum: this.state.minPrice,
      priceMaximum: this.state.maxPrice,
      areaMinimum: this.state.minArea,
      areaMaximum: this.state.maxArea,
      numberOfBedrooms: this.state.noOfBedRooms,
      numberOfBathrooms: this.state.noOfBathRooms,
      homeTypesSelected: this.state[TYPES['HOME']],
    }
  }
  setDefaultFilterObj() {
    return {
      propertyTypesSelected: [],
      priceMinimum: 0,
      priceMaximum: 0,
      areaMinimum: 0,
      areaMaximum: 0,
      numberOfBedrooms: 0,
      numberOfBathrooms: 0,
      homeTypesSelected: [],
    }
  }

  toggleFilters() {
    this.props.actions.toggleFilters()
  }

  handleSorting = evt => {
    const { sortBy, sortOrder } = this.props.filters
    const valueArr = evt.target.getAttribute('value').split('_')
    const sortByVal = valueArr[0]
    const sortOrderVal = valueArr[1]

    if (sortByVal !== sortBy || sortOrderVal !== sortOrder) {
      this.props.actions.handleSorting(sortByVal, sortOrderVal).then(() => {
        this.updateURLFromChangeEvt()
        this.handleOutsideSortByClick()
      })
    } else {
      this.handleOutsideSortByClick()
    }
  }

  getSelectedSortingText = () => {
    const { sortBy, sortOrder } = this.props.filters
    const nodeList = document.querySelectorAll(`li[value=${sortBy}_${sortOrder}]`)
    if (nodeList && nodeList.length) {
      return nodeList[0].innerText
    }
  }

  setSortingOptionSelected = value => {
    const { classes } = this.props
    const { sortBy, sortOrder } = this.props.filters
    return value === `${sortBy}_${sortOrder}` ? classes.checked : ''
  }

  render() {
    const { classes, propertyTypes, homeTypes, toggleMap, filterTypes } = this.props
    const stateObj = this.state
    return (
      <div className={classes.filterRoot}>
        <div className={classes.filterWrapper}>
          <div className={classes.selectRoot}>
            <Button
              className={`${classes.button} ${classes.viewMapbtn}`}
              onClick={() => {
                toggleMap()
                this.setState({ showFilterPanel: false, sortByVisible: false })
              }}>
              View on Map
            </Button>
            <div className={`${classes.customSelectWrapper} ${classes.proTypeSelectWrapper}`}>
              <div
                className={`${classes.proTypeSelect} ${classes.commonSelect} ${this.state.propertyTypeVisible ? 'active' : ''}`}
                onClick={this.handlePropertyTypeClick}>
                <span>
                  {this.state[TYPES['PROPERTY']].length === 0
                    ? 'Property Type'
                    : this.state[TYPES['PROPERTY']].length === 1
                    ? this.state[TYPES['PROPERTY']]
                    : `Property Type (${this.state[TYPES['PROPERTY']].length})`}
                </span>
              </div>
            </div>
            <div className={`${classes.customSelectWrapper} ${classes.priRangeWrapper}`}>
              <div
                className={`${classes.priRangeSelect} ${classes.commonSelect} ${this.state.priceRangeVisible ? 'active' : ''}`}
                onClick={this.handlePriceRangeClick}>
                <span>
                  {(Math.round(this.state.minPrice) === Math.round(this.props.minPrice) &&
                    Math.round(this.state.maxPrice) === Math.round(this.props.maxPrice)) ||
                  this.props.minPrice === null
                    ? 'Price'
                    : Math.round(this.state.minPrice) === Math.round(this.state.maxPrice)
                    ? this.state.minPrice === 0 && this.state.maxPrice === 0
                      ? 'Price'
                      : `$${amtFmt(this.state.minPrice)}`
                    : `$${amtFmt(this.state.minPrice)}-$${amtFmt(this.state.maxPrice)}`}
                </span>
              </div>
            </div>
            <div className={`${classes.customSelectWrapper} ${classes.bedSelectWrapper}`}>
              <div className={`${classes.bedSelect} ${classes.commonSelect} ${this.state.bedSelectVisible ? 'active' : ''}`} onClick={this.bedSelectClick}>
                <span>
                  {this.state.noOfBedRooms === 0 ? '' : this.state.noOfBedRooms}
                  {this.state.noOfBedRooms === 4 ? '+' : ''} Bed{this.state.noOfBedRooms > 1 || this.state.noOfBedRooms < 1 ? 's' : ''}
                </span>
              </div>
            </div>
            <div className={`${classes.customSelectWrapper} ${classes.bathSelectWrapper}`}>
              <div className={`${classes.bedSelect} ${classes.commonSelect} ${this.state.bathSelectVisible ? 'active' : ''}`} onClick={this.bathSelectClick}>
                <span>
                  {this.state.noOfBathRooms === 0 ? '' : this.state.noOfBathRooms}
                  {this.state.noOfBathRooms === 4 ? '+' : ''} Bath{this.state.noOfBathRooms > 1 || this.state.noOfBathRooms < 1 ? 's' : ''}
                </span>
              </div>
            </div>
            {/* Area drop-down html starts here */}
            <div className={`${classes.customSelectWrapper} ${classes.areaRangeWrapper}`}>
              <div
                className={`${classes.priRangeSelect} ${classes.commonSelect} ${this.state.areaTypeVisible ? 'active' : ''}`}
                onClick={this.handleAreaTypeClick}>
                <span>
                  {(Math.round(this.state.minArea) === Math.round(this.props.minArea) && Math.round(this.state.maxArea) === Math.round(this.props.maxArea)) ||
                  this.props.maxArea === null
                    ? 'Area'
                    : Math.round(this.state.minArea) === Math.round(this.state.maxArea)
                    ? `${amtFmt(this.state.minArea)} sqft`
                    : `${amtFmt(this.state.minArea)} sqft-${amtFmt(this.state.maxArea)} sqft`}
                </span>
              </div>
            </div>
            {/* Area drop-down html ends here */}
            <div className={`${classes.customSelectWrapper} ${classes.homeTypeSelectWrapper}`}>
              <div
                className={`${classes.homeTypeSelect} ${classes.commonSelect}
                  ${this.state.homeTypeVisible ? 'active' : ''}`}
                onClick={this.homeTypeClick}>
                <span>
                  <span>
                    {this.state[TYPES['HOME']].length === 0
                      ? 'Home Type'
                      : this.state[TYPES['HOME']].length === 1
                      ? this.state[TYPES['HOME']]
                      : `Home Type (${this.state[TYPES['HOME']].length})`}
                  </span>
                </span>
              </div>
            </div>
            <div className={`${classes.customSelectWrapper} ${classes.sortBySelectWrapper}`}>
              <div
                className={`${classes.sortBySelect} ${classes.commonSelect}
                  ${this.state.sortByVisible ? 'active' : ''}`}
                onClick={this.sortBySelect}>
                <span>
                  <span>{this.getSelectedSortingText()}</span>
                </span>
              </div>
            </div>

            <Button className={`${classes.button} ${classes.moreFilterbtn} ${this.state.moreFilterVisible ? 'active' : ''}`} onClick={this.showMoreFilterPanel}>
              More
            </Button>
            <Button className={`${classes.button} ${classes.viewFilterbtn} ${this.state.showFilterPanel ? 'active' : ''}`} onClick={this.toggleFilterPanel}>
              Filters
            </Button>
          </div>
        </div>
        {/* old filter below or mobile-filter */}
        <Grid container className={this.state.showFilterPanel ? `${classes.mobileFilters} d-flex-imp` : `d-none-imp ${classes.mobileFilters}`}>
          <Grid item>
            {propertyTypes.length ? (
              <div className={classes.marginBottom22}>
                <h4 className={classes.filterH4}>Property Type</h4>
                <div className={classes.filterContent}>
                  {propertyTypes.map((pt, ix) => (
                    <FormControlLabel
                      className={classes.filterChecklabel}
                      key={`pType_${ix}`}
                      control={
                        <Checkbox
                          checked={stateObj[TYPES['PROPERTY']].includes(`${pt}`)}
                          onChange={ev => this.handleTypesChange(ev, TYPES['PROPERTY'])}
                          value={`${pt}`}
                          classes={{
                            root: classes.root,
                            checked: classes.checked,
                          }}
                          disableRipple
                        />
                      }
                      label={pt}
                    />
                  ))}
                </div>
              </div>
            ) : null}
            <div className={classes.marginBottom38}>
              <h4 className={classes.filterH4}>Price Range</h4>
              <PriceRangeSlider filterTypes={filterTypes} sendPriceRange={this.receivePriceRange} />
            </div>
            <div className={classes.marginBottom44}>
              <h4 className={classes.filterH4}>Number of Bedrooms</h4>
              <div className={classes.nmbrOfBeds}>
                <span className={stateObj.noOfBedRooms === 0 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(0)}>
                  Any
                </span>
                <span className={stateObj.noOfBedRooms === 1 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(1)}>
                  1
                </span>
                <span className={stateObj.noOfBedRooms === 2 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(2)}>
                  2
                </span>
                <span className={stateObj.noOfBedRooms === 3 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(3)}>
                  3
                </span>
                <span className={stateObj.noOfBedRooms === 4 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(4)}>
                  4+
                </span>
              </div>
            </div>

            <div className={classes.marginBottom44}>
              <h4 className={classes.filterH4}>Number of Bathrooms</h4>
              <div className={classes.nmbrOfBeds}>
                <span className={stateObj.noOfBathRooms === 0 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(0)}>
                  Any
                </span>
                <span className={stateObj.noOfBathRooms === 1 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(1)}>
                  1
                </span>
                <span className={stateObj.noOfBathRooms === 2 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(2)}>
                  2
                </span>
                <span className={stateObj.noOfBathRooms === 3 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(3)}>
                  3
                </span>
                <span className={stateObj.noOfBathRooms === 4 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(4)}>
                  4+
                </span>
              </div>
            </div>

            <div className={classes.marginBottom38}>
              <h4 className={classes.filterH4}>Area</h4>
              <Area filterTypes={filterTypes} sendAreaRange={this.receiveAreaRange} />
            </div>
            {homeTypes.length ? (
              <div className={classes.marginBottom22}>
                <h4 className={classes.filterH4}>Home Type</h4>
                <div className={classes.filterContent}>
                  {homeTypes.map((ht, ix) => (
                    <FormControlLabel
                      className={classes.filterChecklabel}
                      key={`hType_${ix}`}
                      control={
                        <Checkbox
                          checked={stateObj[TYPES['HOME']].includes(`${ht}`)}
                          onChange={ev => this.handleTypesChange(ev, TYPES['HOME'])}
                          value={`${ht}`}
                          classes={{
                            root: classes.root,
                            checked: classes.checked,
                          }}
                          disableRipple
                        />
                      }
                      label={ht}
                    />
                  ))}
                </div>
              </div>
            ) : null}
            <div className={classes.filterContent}>
              <Button className={classes.applyFilterBtn} onClick={() => this.applySelectedFilters()}>
                {this.props.properties.size > 0 ? 'View results' : 'No results found'}
              </Button>
            </div>
          </Grid>
        </Grid>
        {/* old filter above */}
        {/* tab filter below */}
        <Grid container className={this.state.toggleFilterTabPanel ? `${classes.tabFilters} d-flex-imp` : `d-none-imp ${classes.tabFilters}`}>
          <Grid item>
            <div className={classes.marginBottom44}>
              <h4 className={classes.filterH4}>Number of Bathrooms</h4>
              <div className={classes.nmbrOfBeds}>
                <span className={stateObj.noOfBathRooms === 0 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(0)}>
                  Any
                </span>
                <span className={stateObj.noOfBathRooms === 1 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(1)}>
                  1
                </span>
                <span className={stateObj.noOfBathRooms === 2 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(2)}>
                  2
                </span>
                <span className={stateObj.noOfBathRooms === 3 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(3)}>
                  3
                </span>
                <span className={stateObj.noOfBathRooms === 4 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(4)}>
                  4+
                </span>
              </div>
            </div>
            <div className={classes.marginBottom47}>
              <h4 className={classes.filterH4}>Area</h4>
              <Area filterTypes={filterTypes} sendAreaRange={this.receiveAreaRange} />
            </div>
            {homeTypes.length ? (
              <div className={classes.marginBottom22}>
                <h4 className={classes.filterH4}>Home Type</h4>
                <div className={classes.filterContent}>
                  {homeTypes.map((ht, ix) => (
                    <FormControlLabel
                      className={classes.filterChecklabel}
                      key={`hType_${ix}`}
                      control={
                        <Checkbox
                          checked={stateObj[TYPES['HOME']].includes(`${ht}`)}
                          onChange={ev => this.handleTypesChange(ev, TYPES['HOME'])}
                          value={`${ht}`}
                          classes={{
                            root: classes.root,
                            checked: classes.checked,
                          }}
                          disableRipple
                        />
                      }
                      label={ht}
                    />
                  ))}
                </div>
              </div>
            ) : null}
            <div className={classes.filterContent}>
              <Button className={classes.applyFilterBtn} onClick={() => this.applySelectedFilters()}>
                {this.props.properties.size > 0 ? 'View results' : 'No results found'}
              </Button>
            </div>
          </Grid>
        </Grid>
        {/* tab filter above */}
        {/* property type below */}
        <Grid
          ref={node => {
            this.node = node
          }}
          container
          className={
            this.state.propertyTypeVisible
              ? `${classes.propTypeFilter} ${classes.commonFilterCss} d-flex-imp`
              : `d-none-imp ${classes.propTypeFilter} ${classes.commonFilterCss}`
          }>
          <Grid item className={classes.filterListScroller}>
            {propertyTypes.length ? (
              <div>
                <div className={classes.filterContent}>
                  {propertyTypes.map((pt, ix) => (
                    <FormControlLabel
                      className={classes.filterChecklabel}
                      key={`pType_${ix}`}
                      control={
                        <Checkbox
                          checked={stateObj[TYPES['PROPERTY']].includes(`${pt}`)}
                          onChange={ev => this.handleTypesChange(ev, TYPES['PROPERTY'])}
                          value={`${pt}`}
                          classes={{
                            root: classes.root,
                            checked: classes.checked,
                          }}
                          disableRipple
                        />
                      }
                      label={pt}
                    />
                  ))}
                </div>
              </div>
            ) : null}
          </Grid>
        </Grid>
        {/* property type above */}
        {/* filter for price range below */}
        <Grid
          ref={node => {
            this.node = node
          }}
          container
          className={
            this.state.priceRangeVisible
              ? `${classes.priceRangeFilter} ${classes.commonFilterCss} d-flex-imp`
              : `d-none-imp ${classes.priceRangeFilter} ${classes.commonFilterCss}`
          }>
          <Grid item>
            <div>
              <h4 className={classes.filterH4}>Price Range</h4>
              <PriceRangeSlider filterTypes={filterTypes} sendPriceRange={this.receivePriceRange} />
            </div>
          </Grid>
        </Grid>
        {/* filter for price range above */}
        {/* filter for bedroom below */}
        <Grid
          ref={node => {
            this.node = node
          }}
          container
          className={
            this.state.bedSelectVisible
              ? `${classes.bedFilter} ${classes.commonFilterCss} d-flex-imp`
              : `d-none-imp ${classes.bedFilter} ${classes.commonFilterCss}`
          }>
          <Grid item>
            <div>
              <div className={classes.nmbrOfBeds}>
                <span className={stateObj.noOfBedRooms === 0 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(0)}>
                  Any
                </span>
                <span className={stateObj.noOfBedRooms === 1 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(1)}>
                  1
                </span>
                <span className={stateObj.noOfBedRooms === 2 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(2)}>
                  2
                </span>
                <span className={stateObj.noOfBedRooms === 3 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(3)}>
                  3
                </span>
                <span className={stateObj.noOfBedRooms === 4 ? classes.bgGreen : null} onClick={() => this.handleBedRoomsClick(4)}>
                  4+
                </span>
              </div>
            </div>
          </Grid>
        </Grid>
        {/* filter for bedroom above */}
        {/* filter for bathroom below */}
        <Grid
          ref={node => {
            this.node = node
          }}
          container
          className={
            this.state.bathSelectVisible
              ? `${classes.bathFilter} ${classes.commonFilterCss} d-flex-imp`
              : `d-none-imp ${classes.bathFilter} ${classes.commonFilterCss}`
          }>
          <Grid item>
            <div>
              <div className={classes.nmbrOfBeds}>
                <span className={stateObj.noOfBathRooms === 0 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(0)}>
                  Any
                </span>
                <span className={stateObj.noOfBathRooms === 1 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(1)}>
                  1
                </span>
                <span className={stateObj.noOfBathRooms === 2 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(2)}>
                  2
                </span>
                <span className={stateObj.noOfBathRooms === 3 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(3)}>
                  3
                </span>
                <span className={stateObj.noOfBathRooms === 4 ? classes.bgGreen : null} onClick={() => this.handleBathRoomsClick(4)}>
                  4+
                </span>
              </div>
            </div>
          </Grid>
        </Grid>
        {/* filter for bathroom above */}
        {/* filter for area range below */}
        <Grid
          ref={node => {
            this.node = node
          }}
          container
          className={
            this.state.areaTypeVisible
              ? `${classes.areaRangeFilter} ${classes.commonFilterCss} d-flex-imp`
              : `d-none-imp ${classes.areaRangeFilter} ${classes.commonFilterCss}`
          }>
          <Grid item>
            <div>
              <h4 className={classes.filterH4}>Area</h4>
              <Area filterTypes={filterTypes} sendAreaRange={this.receiveAreaRange} />
            </div>
          </Grid>
        </Grid>
        {/* filter for area range above */}
        {/* tab filter below */}
        <Grid
          ref={node => {
            this.node = node
          }}
          container
          className={
            this.state.homeTypeVisible
              ? `${classes.homeTypeFilter} ${classes.commonFilterCss} d-flex-imp`
              : `d-none-imp ${classes.homeTypeFilter} ${classes.commonFilterCss}`
          }>
          <Grid item className={classes.filterListScroller}>
            {homeTypes.length ? (
              <div>
                <div className={classes.filterContent}>
                  {homeTypes.map((ht, ix) => (
                    <FormControlLabel
                      className={classes.filterChecklabel}
                      key={`hType_${ix}`}
                      control={
                        <Checkbox
                          checked={stateObj[TYPES['HOME']].includes(`${ht}`)}
                          onChange={ev => this.handleTypesChange(ev, TYPES['HOME'])}
                          value={`${ht}`}
                          classes={{
                            root: classes.root,
                            checked: classes.checked,
                          }}
                          disableRipple
                        />
                      }
                      label={ht}
                    />
                  ))}
                </div>
              </div>
            ) : null}
          </Grid>
        </Grid>
        {/* filter for HomeType above */}
        {/* filter for sort by below */}
        <Grid
          ref={node => {
            this.node = node
          }}
          container
          className={
            this.state.sortByVisible
              ? `${classes.sortBySelectList} ${classes.commonFilterCss} d-flex-imp`
              : `d-none-imp ${classes.sortBySelectList} ${classes.commonFilterCss}`
          }>
          <ul onClick={this.handleSorting} className={classes.filterListScroller}>
            <li className={this.setSortingOptionSelected('distance_asc')} value="distance_asc">
              Sort By
            </li>
            <li className={this.setSortingOptionSelected('price_asc')} value="price_asc">
              Price (Low to High)
            </li>
            <li className={this.setSortingOptionSelected('price_desc')} value="price_desc">
              Price (High to Low)
            </li>
            <li className={this.setSortingOptionSelected('date_desc')} value="date_desc">
              Most Recent
            </li>
            <li className={this.setSortingOptionSelected('beds_asc')} value="beds_asc">
              Beds (Low to High)
            </li>
            <li className={this.setSortingOptionSelected('beds_desc')} value="beds_desc">
              Beds (High to Low)
            </li>
            <li className={this.setSortingOptionSelected('baths_asc')} value="baths_asc">
              Baths (Low to High)
            </li>
            <li className={this.setSortingOptionSelected('baths_desc')} value="baths_desc">
              Baths (High to Low)
            </li>
            <li className={this.setSortingOptionSelected('sqft_asc')} value="sqft_asc">
              Sqft (Low to High)
            </li>
            <li className={this.setSortingOptionSelected('sqft_desc')} value="sqft_desc">
              Sqft (High to Low)
            </li>
            <li className={this.setSortingOptionSelected('homeType_asc')} value="homeType_asc">
              Home Type (Low to High)
            </li>
            <li className={this.setSortingOptionSelected('homeType_desc')} value="homeType_desc">
              Home Type (High to Low)
            </li>
            <li className={this.setSortingOptionSelected('type_asc')} value="type_asc">
              Property Type (Low to High)
            </li>
            <li className={this.setSortingOptionSelected('type_desc')} value="type_desc">
              Property Type (High to Low)
            </li>
          </ul>
        </Grid>
        {/* filter for sort by above */}
      </div>
    )
  }
}

Filters.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  let propertyTypes = []
  let homeTypes = []
  let minArea, maxArea, minPrice, maxPrice
  if (state.filters.filterTypes.length > 0) {
    propertyTypes = state.filters.filterTypes[2].value
    homeTypes = state.filters.filterTypes[3].value
    minArea = state.filters.filterTypes[1].value[0]
    maxArea = state.filters.filterTypes[1].value[1]
    minPrice = state.filters.filterTypes[0].value[0]
    maxPrice = state.filters.filterTypes[0].value[1]
  }
  return {
    propertyTypes: propertyTypes,
    homeTypes: homeTypes,
    minArea: minArea,
    maxArea: maxArea,
    minPrice: minPrice,
    maxPrice: maxPrice,
    searchLocation: state.properties.loc,
    filters: state.filters,
    viewPort: state.properties.get('viewPort'),
    properties: state.properties.get('data'),
    filterTypes: state.filters.get('filterTypes'),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const filters = connect(
  mapStateToProps,
  mapDispatchToProps
)(Filters)

export default withStyles(styles)(withRouter(filters))



// WEBPACK FOOTER //
// ./src/components/Filters.js